import Vue from 'vue'
import AjaxAPI from '../helpers/AjaxAPI'
import {getPrice, getSizedImageUrl} from '../helpers/shopify'
import log from 'salvo-lite/log'
import axios from 'axios'

class VueCart {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._data = {
            emptyClass: 'cart-empty',
            ...JSON.parse(elem.querySelector('[data-cart-info]').innerHTML || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        this._vueCart()

        document.body.addEventListener('click', e => {
            if (!e.target.closest('[data-proxy-dropdown]')) {
                const openDropdowns = document.querySelectorAll('.proxy-dropdown__list.open')
                for (let openDropdown of openDropdowns) {
                    openDropdown.classList.remove('open')
                }
            }
        })
    }

    async _vueCart () {
        const cartJSON = JSON.parse(document.querySelector('[data-cart-json]').innerHTML)
        const { emptyClass, freeGift } = this._data

        freeGift.activeProduct = freeGift.products[freeGift.activeProductKey]

        if (freeGift.activeProduct.variants) {
            freeGift.selectedVariant = freeGift.activeProduct.variants.find(variant => {
                let isVariant = true

                variant.options.forEach((option, index) => {
                    if (option !== freeGift.activeProduct.optionsWithValues[index].values[0]) {
                        isVariant = false
                    }
                })

                return isVariant
            })

            if (!freeGift.selectedVariant) {
                freeGift.selectedVariant = freeGift.activeProduct.variants[0]
            }

            if (!freeGift.selectedVariant.featured_image) {
                freeGift.selectedVariant.featured_image = freeGift.activeProduct.media[0]
            }
        }
        /*
            Vue Instance
        */
        const vue = new Vue({
            el: '[data-vue-cart]',
            data: {
                cart: cartJSON.cart,
                products: cartJSON.products,
                cartButton: document.querySelector('.cart-product-count'),
                freeGift,
                freeGiftLoaded: false
            },
            mounted () {
                this._addThreshold()
                this.$el.classList.add('rendered')

                if (this.freeGift.selectedVariant) {
                    this.setActiveProductOptions()
                }

                this.checkForFreeGift()
                this.disableFreeGiftCTA()
            },
            computed: {
                totalLoyaltyPoints () {
                    const loyaltyPointerPerPound = document.querySelector('[data-loyalty-points-per-pound]').getAttribute('data-loyalty-points-per-pound')
                    const totalLoyaltyPoints = Math.floor((loyaltyPointerPerPound * this.cart.total_price) / 100)
                    return totalLoyaltyPoints
                },
                remainingForFreeDelivery () {
                    const freeDeliveryThreshold = parseInt(document.querySelector('[data-free-delivery]').getAttribute('data-free-delivery')) * 100
                    return getPrice(freeDeliveryThreshold - this.cart.total_price)
                },
                showFreeGiftBox () {
                    const freeGiftThresholdInt = this.freeGift.minThreshold * 100
                    const hasReachedThreshold = this.cart.total_price >= freeGiftThresholdInt
                    const matchingFreeGift = this.cart.items.some(item => item.properties && item.properties['threshold-free-product'])
                    return hasReachedThreshold && !matchingFreeGift
                }
            },
            filters: {
                money (price) { return getPrice(price) },
                img_url (imageSrc, dimensions) { return getSizedImageUrl(imageSrc, dimensions) }
            },
            methods: {
                async checkForFreeGift () {
                    const res = await AjaxAPI.getCart()
                    const items = res.data.items
                    let hasFreeGift = false
                    let inCart = false
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].properties && items[i].properties['threshold-free-product']) {
                            hasFreeGift = true
                            break
                        }
                    }
                    for (let i = 0; i < this.cart.items.length; i++) {
                        if (this.cart.items[i].properties && this.cart.items[i].properties['threshold-free-product']) {
                            inCart = true
                            break
                        }
                    }

                    if (hasFreeGift !== inCart) {
                        location.reload()
                        return
                    }

                    this.freeGiftLoaded = true
                },
                setActiveProductOptions () {
                    this.freeGift.selectedOptions = []
                    this.freeGift.activeProduct.options.forEach((option, index) => {
                        this.freeGift.selectedOptions[`option${index + 1}`] = (this.freeGift.activeProduct.optionsWithValues[index].values.length === 1)
                            ? this.freeGift.selectedVariant[`option${index + 1}`] : ''
                    })
                },
                updateCart: async function () {
                    let payload = {}
                    for (let item of this.cart.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const cartObject = await AjaxAPI.updateItems(payload)
                        if (cartObject.status === 200) {
                            this.cart = cartObject.data
                        }
                    }
                    this.checkFreeGiftThreshold()
                    this.updateEmptyCartState()
                    this.updateCartItemCount()
                    this.disableFreeGiftCTA()
                },
                removeBundle: async function (bundleId) {
                    const payload = {}
                    for (let item of this.cart.items) {
                        if (item.properties['_bundle_id'] === bundleId) {
                            payload[item.key] = 0
                        }
                    }
                    if (payload) {
                        const cartObject = await AjaxAPI.updateItems(payload)
                        if (cartObject.status === 200) {
                            this.cart = cartObject.data
                            this.updateCartItemCount()
                            this.checkFreeGiftThreshold()
                            this.updateEmptyCartState()
                        }
                    }
                },
                getCartImages: async function (items = null) {
                    const cartItems = (items !== null) ? items : this.cart.items
                    this.cartImages = await AjaxAPI.getCartImages(cartItems)
                },
                updateCartState (open = false) {
                    this.updateEmptyCartState()
                    this.updateCartItemCount()
                    open && this.openCart()
                },
                removeItem (e, item) {
                    if (item.properties && item.properties.picknmix) {
                        const bundleId = item.properties['_bundle_id']
                        return this.removeBundle(bundleId)
                    }

                    item.quantity = 0

                    if (item.properties && item.properties['Free Gift']) {
                        const freeGiftProductID = parseInt(item.properties['Free Gift'])
                        const freeGiftItem = this.cart.items.find(item => item.id === freeGiftProductID)
                        if (typeof freeGiftItem !== 'undefined') {
                            freeGiftItem.quantity = 0
                        }
                    }

                    this.updateCart()
                },
                increaseQuantity (e, item) {
                    item.quantity++
                    this.updateCart()
                },
                decreaseQuantity (e, item) {
                    item.quantity--
                    if (item.quantity < 1) this.removeItem(e, item)
                    this.updateCart(e)
                },
                updateQuantity (e, item) {
                    item.quantity = e.target.value
                    this.updateCart()
                },
                updateEmptyCartState () {
                    this.cart.item_count === 0 ? this.$el.parentElement.classList.add(emptyClass) : this.$el.parentElement.classList.remove(emptyClass)
                },
                updateCartItemCount () {
                    const cartSummary = document.querySelector('.cart-summary-count')
                    let itemCount = this.cart.item_count
                    this.cart.items.forEach(item => {
                        if (item.handle === 'pnm' || item.handle === 'carb-killa-pick-n-mix') itemCount = itemCount - item.quantity
                    })
                    this.cartButton.textContent = itemCount
                    cartSummary.textContent = itemCount
                },
                editVariants (e, close = false) {
                    const cartOptions = e.target.closest('[data-cart-product]').querySelector('.cart-item__options')
                    if (close) {
                        cartOptions.classList.remove('editing')
                    } else {
                        const otherOpenCartOptions = document.querySelector('.cart-item__options.editing')
                        if (otherOpenCartOptions && otherOpenCartOptions !== cartOptions) {
                            otherOpenCartOptions.classList.remove('editing')
                        }
                        cartOptions.classList.toggle('editing')
                    }
                },
                getItemProduct: async function (item) {
                    const product = await AjaxAPI.getProduct(item.handle)
                    if (product.status === 200) item.product = product.data
                },
                openDropdown (e) {
                    if (e.target.closest('[data-proxy-dropdown-selected]').nextElementSibling.classList.contains('open')) {
                        e.target.closest('[data-proxy-dropdown-selected]').nextElementSibling.classList.toggle('open')
                    } else {
                        let openDropdowns = document.querySelectorAll('.proxy-dropdown__list.open')
                        for (let openDropdown of openDropdowns) {
                            openDropdown.classList.remove('open')
                        }
                        e.target.closest('[data-proxy-dropdown-selected]').nextElementSibling.classList.add('open')
                    }
                },
                updateSelectedDropdownValue (item, product, value, optionIndex) {
                    const potentialVariants = product.variants.filter(variant => variant[`option${optionIndex}`] === value)

                    potentialVariants.forEach(async variant => {
                        let match = true
                        variant.options.forEach((productOption, index) => {
                            if (index !== optionIndex - 1) {
                                const variantOptionKey = `option${index + 1}`
                                if (variant[variantOptionKey] !== item.options_with_values[index].value) {
                                    match = false
                                }
                            }
                        })

                        if (match) {
                            const updatePayload = {
                                [item.id]: 0,
                                [variant.id]: item.quantity
                            }
                            const updatedCart = await AjaxAPI.updateItems(updatePayload)
                            if (updatedCart.status === 200) this.cart = updatedCart.data
                            this.updateCart()
                        }
                    })
                },
                disabledVariant (item, product, value, optionIndex) {
                    const potentialVariants = product.variants.filter(variant => variant[`option${optionIndex}`] === value)
                    let disabled = false

                    potentialVariants.forEach(variant => {
                        let match = true
                        variant.options.forEach((productOption, index) => {
                            if (index !== optionIndex - 1) {
                                const variantOptionKey = `option${index + 1}`
                                if (variant[variantOptionKey] !== item.options_with_values[index].value) {
                                    match = false
                                }
                            }
                        })

                        if (match) {
                            disabled = !variant.available
                        }
                    })

                    return disabled
                },
                changeClass (e, element, className, action, targetOnlyRef) {
                    if (!targetOnlyRef || (targetOnlyRef && e.target === this.$refs[targetOnlyRef])) {
                        document.querySelector(element) && document.querySelector(element).classList[action](className)
                    }

                    if (action === 'add') {
                        const checkboxes = document.querySelectorAll('input[name="free-gift-option"]')
                        if (checkboxes.length) {
                            checkboxes.forEach(cb => {
                                cb.checked = false
                            })
                            checkboxes[0].click()
                        }
                    }
                },
                isFreeGift (item) {
                    return item.properties ? item.properties['threshold-free-product'] : false
                },
                updateActiveFreeGift (e) {
                    if (e.target.checked) {
                        this.freeGift.activeProductKey = e.target.value
                        this.freeGift.activeProduct = freeGift.products[freeGift.activeProductKey]
                        this.freeGift.selectedVariant = freeGift.activeProduct.variants.find(variant => {
                            let isVariant = true

                            variant.options.forEach((option, index) => {
                                if (option !== freeGift.activeProduct.optionsWithValues[index].values[0]) {
                                    isVariant = false
                                }
                            })

                            return isVariant
                        })

                        this.$nextTick(() => {
                            this.clearFreeGiftOptions()

                            const optionElements = Array.from(document.querySelectorAll('[data-free-gift-option]'))
                            optionElements.forEach((element, index) => {
                                const multiple = element.options.length > 2
                                this.freeGift.selectedOptions[`option${index + 1}`] = multiple ? '' : element.options[1].value
                                element.value = multiple ? 'null' : element.options[1].value
                                element.closest('.proxy-dropdown').querySelector('[data-proxy-dropdown-selected-inner] span').textContent = element.options[multiple ? 0 : 1].textContent
                            })

                            this.setActiveProductOptions()
                            this.disableFreeGiftCTA()
                        })
                    }
                },
                updateFreeGiftOption (e, value, optionIndex) {
                    this.freeGift.selectedVariant = this.freeGiftMatchingVariant(value, optionIndex)
                    this.freeGift.selectedOptions[`option${optionIndex + 1}`] = value
                    const optionWrapper = e.target.closest('[data-option]')
                    optionWrapper.querySelector('select').value = value
                    optionWrapper.querySelector('[data-proxy-dropdown-selected-inner] span').textContent = value
                    optionWrapper.querySelector('[data-proxy-dropdown-list]').classList.remove('open')

                    this.disableFreeGiftCTA()
                },
                clearFreeGiftOptions () {
                    const containers = document.querySelectorAll('.product-variants__option-values')
                    containers.forEach(container => {
                        const select = container.querySelector('select')
                        select.value = null
                    })
                },
                disableFreeGiftCTA () {
                    const addFreeGiftCTA = document.querySelector('[data-add-free-gift]')

                    if (!addFreeGiftCTA) return

                    const freeGiftOptions = this.freeGift.selectedOptions
                    let disabled = false
                    for (const prop in freeGiftOptions) {
                        if (freeGiftOptions[prop] === '') {
                            disabled = true
                            break
                        }
                    }
                    addFreeGiftCTA.disabled = this.freeGift.selectedVariant && this.freeGift.selectedVariant.available ? disabled : true
                },
                freeGiftMatchingVariant (value, optionIndex) {
                    const options = this.freeGift.activeProduct.optionsWithValues
                    const otherOptions = options.filter((option, index) => index !== optionIndex)

                    const currentOptionKey = `option${optionIndex + 1}`
                    const potentialMatchingVariants = this.freeGift.activeProduct.variants.filter(variant => variant[currentOptionKey] === value)
                    let matchingVariant

                    if (!this.freeGift.selectedVariant) {
                        return null
                    }

                    potentialMatchingVariants.forEach(variant => {
                        let match = true
                        otherOptions.forEach(option => {
                            if (variant[`option${option.position}`] !== this.freeGift.selectedVariant[`option${option.position}`]) {
                                match = false
                            }
                        })
                        if (match) matchingVariant = variant
                    })

                    return matchingVariant
                },
                freeGiftMatchingVariantProperty (value, optionIndex, property) {
                    const matchingVariant = this.freeGiftMatchingVariant(value, optionIndex)
                    return matchingVariant ? matchingVariant[property] : null
                },
                async addFreeGift (event) {
                    event.target.disabled = true
                    const checkboxes = document.querySelectorAll('.free-product-popup__gender-options input')
                    checkboxes.forEach(checkbox => (checkbox.disabled = true))
                    const payload = {
                        quantity: 1,
                        id: parseInt(this.freeGift.selectedVariant.id),
                        properties: {
                            'threshold-free-product': 1
                        }
                    }

                    const RESPONSE = await AjaxAPI.addItem(payload)
                    this.cart = RESPONSE.cart.data
                    this.products.push(RESPONSE.product.data)
                    this.updateCart()
                    this.changeClass(event, '.free-product-popup', 'shown', 'remove')
                    checkboxes.forEach(checkbox => (checkbox.disabled = false))
                },
                checkFreeGiftThreshold () {
                    if (this.cart.items.find(item => item.properties && item.properties['threshold-free-product'])) {
                        if (this.cart.total_price < this.freeGift.minThreshold * 100) {
                            const freeGiftItem = this.cart.items.find(item => item.properties['threshold-free-product'])
                            freeGiftItem.quantity = 0
                            this.updateCart()
                        }
                    }
                },
                isActiveBundleItem (item) {
                    if (!item.properties) return false
                    const bundleID = item.properties._bundle_id
                    let itemsInBundle
                    if (bundleID) itemsInBundle = this.cart.items.filter(item => item.properties._bundle_id === bundleID)
                    return itemsInBundle && itemsInBundle.length > 1
                },
                async _addThreshold () {
                    if (!this.cart.attributes.freeGiftThreshold) {
                        const threshold = this.freeGift.minThreshold * 100
                        await axios.post('/cart/update.js', `attributes[freeGiftThreshold]=${threshold}`)
                    }
                }
            }
        })

        window.vueJob = vue
    }
}

export default VueCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VueCart.js